import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import { YMInitializer } from 'react-yandex-metrika';
import ReactGA from 'react-ga';
import './main.critical.css';
import './index.css';
import Home from './pages/home/home';
import Menu from './components/menu/menu';
import Logo from './components/logo/logo';
import Blur from './components/blur/blur'
import reducers from './reducers'
import { unregister } from './registerServiceWorker';

// import registerServiceWorker from './registerServiceWorker';
// const createStoreWithMiddleware = applyMiddleware(createStore);
const Store = createStore(reducers);

ReactGA.initialize('UA-88014128-25');


ReactDOM.render(
  <Provider store={Store}>
    <div>
      <YMInitializer accounts={[42193809]} />

      <BrowserRouter>
          <div className="page">

            <Blur>
              <div className="page__content">
                <Switch>
                  <Route path="/" component={Home} />
                </Switch>
              </div>
            </Blur>

            <div className="sidebar">
              <Logo image="porsche" link="https://porsche-russland.ru/pdc/club/?utm_source=Championat&utm_medium=SP&utm_campaign=Special_Project" mobile />
              <Menu />
              <Logo image="championat" link="https://www.championat.com/" />
            </div>

          </div>
        </BrowserRouter>
    </div>
  </Provider>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js